import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';

@inject('Game3Store')
@observer
export default class Game3Step1 extends Component {

    render() {
        return (
            <div className="step-1">
                <h1>Running Against the Clock</h1>
                <p>
                    In our everyday tasks, we have to cope with time respecting deadlines and handing in good-
                    quality work. Play a quiz game together with your classmates and put the skills you studied
                    about meeting deadlines into practice.<br/>
                    Each group will have four tasks to do in ten minutes.<br/>
                    <br/>
                    <b>Score:</b><br/>
                    <br/>
                    Time<br/>
                    • All tasks finished on time – 10 points<br/>
                    • Three tasks finished on time – 8 points<br/>
                    • Two tasks finished on time – 6 points<br/>
                    • One task finished on time – 4 points<br/>
                    • No task done – 0 points<br/>
                    <br/>
                    Correct Task<br/>
                    • Each correct task – 5 points<br/>
                    • Each incomplete task – 2 points<br/>
                    • Each incorrect task – 0 points<br/>
                </p>
            </div>
        )
    }

};


// WEBPACK FOOTER //
// ./src/containers/Game3/Game3Step1.js